module.exports = __webpack_public_path__ + "img/modern.3d2ffb0c.svg";